import { render, staticRenderFns } from "./Octagon.vue?vue&type=template&id=72dc9777"
import script from "./Octagon.vue?vue&type=script&lang=js"
export * from "./Octagon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports